import React, { useState } from 'react';
import { createComment, updateComment } from '../../api/boardApi';

const CommentForm = ({
  postId,
  codeId,
  parentId = null,
  commentId = null,
  initialContent = '',
  onSuccess,
  isEdit = false,
  token,
}) => {
  const [content, setContent] = useState(initialContent);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!content.trim()) return;
    try {
      if (isEdit) {
        await updateComment(commentId, { content }, token);
      } else {
        await createComment(
          {
            post_id: postId,
            code_id: codeId,
            parent_id: parentId,
            content,
            depth: parentId ? 1 : 0,
          },
          token
        );
      }
      setContent('');
      if (onSuccess) onSuccess();
    } catch (err) {
      console.error('댓글 처리 실패:', err);
    }
  };

  return (
    <div className="comment-form-container">
      <form onSubmit={handleSubmit}>
        <textarea
          value={content}
          onChange={(e) => setContent(e.target.value)}
          placeholder="댓글을 입력하세요..."
          rows={3}
          className="comment-form-textarea"
        />
        <div className="comment-submit-row">
          <button type="submit" className="comment-submit-btn">
            {isEdit ? '수정 완료' : '댓글 등록'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default CommentForm;